
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin, RyzerMixin } from '@/mixins';

@Component
export default class RyzerAthleteTypeCard extends Mixins(VuetifyMixin, RyzerMixin){
}
